import { Component } from "react";
import debounce from "lodash-es/debounce";
import { Highcharts } from "extensions/highcharts";
import {
    HighchartsChart,
    Chart,
    HighchartsProvider,
    YAxis,
    XAxis,
    AreaSeries
} from "react-jsx-highcharts";

import { sortAndFillGaps } from "../widgetHelper";

export class QuickAreaChart extends Component {
    static trimNullsFromData(data) {
        let endIsNull = data && data.length > 0;
        while (endIsNull) {
            if (data[data.length - 1] === null) {
                data.pop();
            } else {
                endIsNull = false;
            }
        }
    
        let startIsNull = data && data.length > 0;
        while (startIsNull) {
            if (data[0] === null) {
                data.shift();
            } else {
                startIsNull = false;
            }
        }
        return data;
    }
    
    constructor(props) {
        super(props);
        this.resizeMethod = debounce(this.reflowChart.bind(this), 300);
    }
    
    componentDidMount() {
        window.addEventListener("resize", this.resizeMethod);
    }
    
    componentWillUnmount() {
        // Cancel any pending debounce func
        this.resizeMethod.cancel();
        
        window.removeEventListener("resize", this.resizeMethod);
    }
    
    getChart = (chart) => {
        this.chart = chart;
    };
    
    getAPIEndpoint() {
        const endpoint = this.props.subModel.get("api_endpoint");
        const pivot = this.props.second_pivot_key;
        
        return typeof endpoint === "function" ? endpoint(pivot) : endpoint;
    }
    
    reflowChart() {
        if (this.chart) {
            this.chart.reflow();
            this.chart.setSize(null, this.props.widgetContainer.offsetHeight);
        }
    }
    
    processData(base, toggle) {
        // fill gaps code..??
        const props = this.props;
        const by = props.by || "count";
        const field = toggle ? `${base}_${by}` : base;
        const days = props.dateRanges[0].days;
        const startDate = props.dateRanges[0].startDate;
        const sortedData = sortAndFillGaps(days, startDate, props.data);
        return sortedData.map((r) => r[field] || null);
    }
    
    render() {
        const reactProps = this.props.subModel.getClone("quick").reactProps;
        const data = this.processData(reactProps.chartField, reactProps.chartFieldToggle);
        const cleanData = QuickAreaChart.trimNullsFromData(data);
        
        const chartOptions = {
            plotOptions: {
                area: {
                    color: reactProps.color,
                    fillColor: reactProps.fillColor,
                    connectNulls: true
                },
                series: {
                    lineWidth: 2,
                    animation: false,
                    marker: {
                        enabled: false
                    },
                    states: {
                        hover: {
                            enabled: false
                        }
                    },
                    allowPointSelect: false
                }
            },
            chart: {
                height: this.props.chartHeight,
                marginTop: this.props.chartHeight * 0.6,
                marginRight: 0,
                marginBottom: 0,
                marginLeft: 0,
                backgroundColor: "rgba(0,0,0,0)"
            },
            yAxis: {
                gridLineWidth: 0,
                minorGridLineWidth: 0,
                lineColor: "transparent",
                labels: {
                    enabled: false
                },
                minorTickLength: 0,
                tickLength: 0,
                minRange: 1,
                floor: Math.min(...cleanData) * 0.96,
                ceiling: Math.max(...cleanData)
            },
            xAxis: {
                startOnTick: false,
                endOnTick: false,
                minPadding: 0,
                maxPadding: 0,
                lineWidth: 0,
                minorGridLineWidth: 0,
                lineColor: "transparent",
                labels: {
                    enabled: false
                },
                minorTickLength: 0,
                tickLength: 0
            },
            tooltip: {
                enabled: false
            },
            legend: {
                enabled: false
            }
        };
        
        return (
            <div className="chartArea">
                <HighchartsProvider Highcharts={Highcharts}>
                    <HighchartsChart callback={this.getChart} plotOptions={chartOptions.plotOptions} >
                        <Chart reflow="true" {...chartOptions.chart}/>
                        
                        <XAxis id="myXaxis" {...chartOptions.xAxis} />
        
                        <YAxis id="myYaxis" {...chartOptions.yAxis}>
                            <AreaSeries name="lineData" data={cleanData} />
                        </YAxis>
                    </HighchartsChart>
                </HighchartsProvider>
            </div>
        );
    }
}
